import { CustomFormControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

type Param = {
  customFormId: string;
  status: boolean;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const useFormBuilderArchiveStatus = () =>
  useMutationWithLoading(async (param: Param) =>
    new CustomFormControllerApi(getConfigObject()).updateArchiveStatus2(
      param.customFormId,
      param.status,
      param?.xTENANTID
    )
  );
